import { TemplateComponent } from '../DocumentGenerator';

export type OrganizationParts = {
  organization: { label?: string };
  subsidiary?: { description?: string };
  customOrgName?: string;
};

export type OrganizationTemplateType = { name: string; formatted: string };

/**
 * By default, using 'organization' will return a dynamic representation of the organization's name. (custom -> subsidiary -> label)
 */
export const OrganizationComponent: TemplateComponent<OrganizationParts, OrganizationTemplateType, void, false> = {
  templatize: ({ organization, customOrgName, subsidiary }) => {
    const formatted = customOrgName ?? subsidiary?.description ?? organization?.label ?? '';

    return { toString: () => formatted, formatted, name: organization?.label ?? '' };
  },
  definitionMap: { name: { label: 'Name', type: 'string' }, formatted: { label: 'Formatted Name', type: 'string' } },
};
